module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAwBAMAAACYvoXSAAAAFVBMVEV0dHR0dHR0dHR0dHR0dHR0dHR0dHTfIRJbAAAABnRSTlMASUrk5udXTd49AAAALUlEQVQ4y2MQScMCHBncsAmnMKRhBdQRxmplKoMqNmEjhlGACUbjcviAIRqXAAQ2ztSckUWsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/left-menu.png
// module id = 97/V
// module chunks = 1